import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import '../styles/css/dashboard.css';
import { connect } from 'react-redux';
import { getChapters } from '../actions/DashboardAction';
import { setContent } from '../actions/AuthAction';
import AssignmentContainer from './AssignmentContainer';
import Spinner from '../components/Spinner';
import { pageView, trackEvent } from '../util/tracking';
import ChapterTable from '../components/ChapterTable';

class Dashboard extends React.Component {

  componentDidMount() {
    if (!this.props.chapters || !this.props.chapters.length) {
      this.props.getChapters();
    }
    pageView();
    trackEvent('DASHBOARD', 'See Dashboard', '');
  }

  render() {
    const Page = () => (
      <Switch>
        <Route
          exact
          path={'/dashboard'}
          render={() => <ChapterTable chapters={this.props.chapters} />}
        />
        <Route
          exact
          path={'/dashboard/:chapterNumber/:category/:memberChapterId'}
          component={AssignmentContainer}
        />
        <Route
          path={'/dashboard/:something'}
          render={() => <Redirect to='/dashboard' />}
        />
      </Switch>
    );
    if (!this.props.chapters || !this.props.chapters.length) {
      return <Spinner />;
    } else {
      return (
        <div className='dashboard-container'>
          <Page />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    chapters: state.dashboard.chapters,
    userState: state.auth.userState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getChapters: () => {
      dispatch(getChapters());
    },
    setContent: courseId => {
      dispatch(setContent(courseId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js